export default __webpack_public_path__ + "static/media/fabulous.d8fa3656.png";